module.exports = __webpack_public_path__ + "static/img/floor3-zcfjwwg.9a11266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-zcfjwwg.png
// module id = k6EP
// module chunks = 1